import 'vant/lib/index.css';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import {
    Button,
    Field,
    NoticeBar,
    Popup,
} from "vant";
import JsonExcel from "vue-json-excel";
import Vue from "vue";
import {LoadingBar, Modal} from "view-design";
Vue.use(Button)
Vue.use(Field)
Vue.use(NoticeBar)
Vue.use(Popup)
Vue.component("downloadExcel", JsonExcel);
Vue.prototype.$Modal=Modal
Vue.prototype.$Loading=LoadingBar
